import React, { Component } from "react";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import List, { ItemDragging, MenuItem, ListTypes } from "devextreme-react/list";
import DataSource from "devextreme/data/data_source";
import { LoadPanel } from "devextreme-react/load-panel";
import { SelectBox } from "devextreme-react/select-box";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import RadioGroup from "devextreme-react/radio-group";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";

const position = { of: "#historydiv" };
const CrewTypeCategoryLst = [
  { code: "P", name: "Cockpit" },
  { code: "F", name: "Cabin Crew" },
  { code: "both", name: "Both" },
];

const ItemTemplate = (item) => {
  return (
    <p
      style={{
        margin: "0px",
      }}
    >
      <span>{item.priority}</span>
      <span style={{ marginLeft: "50px" }}>{item.hotelName}</span>
      <span style={{ alignItems: "right" }}></span>
    </p>
  );
};
export class HotelBookingPriority extends Component {
  static displayName = HotelBookingPriority.name;
  constructor(props) {
    super(props);
    this.state = {
      loadPanelVisible: false,
      isFiltered: false,
      isSubmitted: false,
      filterAirportDropdownDataSource: null,
      filterAirportCode: "",
      hotelBookingPriorityDataSource: [],
      showSetPriorityModal: false,
      airportDropdownDataSource: null,
      airportCode: "",
      hotelDropdownDataSource: null,
      hotelCode: "",
      crewTypeCategoryDataSource: CrewTypeCategoryLst,
      crewTypeCategoryCode: "both",
      errors: {
        filterAirport: "",
        airport: "",
        hotel: "",
        crewTypeCategoryCode: "",
      },
    };
    this.isUseEffectRendered = false;
    this.reorderGroupNo = 0;
    this.refList = React.createRef();
  }
  componentDidMount() {
    try {
      if (this.isUseEffectRendered) {
        return;
      }
      this.isUseEffectRendered = true;
      this.getAirportDropdownList();
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".componentDidMount function",
        error,
      );
    }
  }
  getAirportDropdownList = () => {
    try {
      setTimeout(async () => {
        let airlineCode = sessionStorage.getItem("session_airlineCode");
        const response = await axiosGet(
          `Airport/get-airport-dropdown/${airlineCode}`,
        );
        let airportDropdownDataLst =
          response?.payload?.sort((a, b) =>
            a.airportCode.localeCompare(b.airportCode),
          ) ?? [];
        this.setState((prev) => ({
          ...prev,
          filterAirportDropdownDataSource: airportDropdownDataLst,
          airportDropdownDataSource: [...airportDropdownDataLst],
        }));
      }, 0);
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".getAirportDropdownList function",
        error,
      );
    }
  };
  handleOnFilterAirportDropdownChange = (e) => {
    try {
      let err = this.state.errors;
      err.filterAirport = "";
      let airportCode = e.value ?? "";
      this.setState((prev) => ({
        ...prev,
        filterAirportCode: airportCode,
        hotelBookingPriorityDataSource: [],
        errors: err,
      }));
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnFilterAirportDropdownChange function",
        error,
      );
    }
  };
  handelOnGetHotelBookingPriority = async () => {
    try {
      const airportCode = this.state.filterAirportCode;
      let err = this.state.errors;
      err.filterAirport = "";
      if (airportCode.trim() === "") {
        err.filterAirport = "Please select airport";
        this.setState((prev) => ({
          ...prev,
          errors: err,
        }));
        return;
      }
      this.setState((prev) => ({
        ...prev,
        isFiltered: true,
      }));
      await this.getHotelBookingPriority();
      this.setState((prev) => ({
        ...prev,
        isFiltered: false,
      }));
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handelOnGetHotelBookingPriority function",
        error,
      );
    }
  };
  getHotelBookingPriority = async () => {
    try {
      if (this.state.filterAirportCode.trim() !== "") {
        this.setState((prev) => ({
          ...prev,
          loadPanelVisible: true,
        }));
        let airlineCode = sessionStorage.getItem("session_airlineCode");
        const airportCode = this.state.filterAirportCode;
        let request = {};
        request.AirlineCode = airlineCode;
        request.AirportCode = airportCode;
        const response = await axiosPost(
          "HotelBooking/get-hotel-priority-list",
          request,
        );
        let hotelBookingPriorityDataLst = response?.payload ?? [];

        let dataGropList = [
          ...new Set(
            hotelBookingPriorityDataLst.map((item) => ({
              ...item,
              groupText: `( ${item.airportCode} ) ${item.crewTypeCategory}`,
              groupKey: `${item.airportCode}${item.crewTypeCategory}`,
            })),
          ),
        ];
        this.setState((prev) => ({
          ...prev,
          hotelBookingPriorityDataSource: dataGropList,
          loadPanelVisible: false,
        }));
        // if (this.reorderGroupNo >= 0) {
        //   this.refList.current.instance.expandGroup(this.reorderGroupNo);
        // }
      }
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handelOnGetHotelBookingPriority function",
        error,
      );
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
    }
  };
  getHotelDropdownList = async (airportCode) => {
    try {
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let hotelDropdownDataLst = [];
      if (airportCode) {
        const response = await axiosGet(`/Hotel/get-hotel-dropdown`, {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: airportCode,
        });
        hotelDropdownDataLst =
          response?.payload?.sort((a, b) =>
            a.hotelName.localeCompare(b.hotelName),
          ) ?? [];
      }
      this.setState((prev) => ({
        ...prev,
        hotelDropdownDataSource: hotelDropdownDataLst,
        loadPanelVisible: false,
      }));
    } catch (error) {
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
      console.log(
        "Error in " + this.displayName + ".getHotelDropdownList function",
        error,
      );
    }
  };
  handleOnCloseSetPriorityModal = () => {
    try {
      let err = this.state.errors;
      err.airport = "";
      err.hotel = "";
      err.crewTypeCategoryCode = "";
      this.setState((prev) => ({
        ...prev,
        airportCode: "",
        hotelDropdownDataSource: [],
        hotelCode: "",
        crewTypeCategoryCode: "both",
        showSetPriorityModal: false,
        errors: err,
      }));
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnCloseSetPriorityModal function",
        error,
      );
    }
  };
  handleOnAirportDropdownChange = async (e) => {
    try {
      let err = this.state.errors;
      err.airport = "";
      let airportCode = e.value ?? "";
      this.setState((prev) => ({
        ...prev,
        airportCode: airportCode,
        errors: err,
      }));
      await this.getHotelDropdownList(airportCode);
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnAirportDropdownChange function",
        error,
      );
    }
  };
  handleOnHotelDropdownChange = (e) => {
    try {
      let err = this.state.errors;
      err.hotel = "";
      let hotelCode = e.value ?? "";
      this.setState((prev) => ({
        ...prev,
        hotelCode: hotelCode,
        errors: err,
      }));
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnHotelDropdownChange function",
        error,
      );
    }
  };
  handelOnChangeSelectionCrewType = (e) => {
    try {
      let err = this.state.errors;
      err.crewTypeCategoryCode = "";
      let crewTypeData = e.value ?? "";
      this.setState((prev) => ({
        ...prev,
        crewTypeCategoryCode: crewTypeData,
        errors: err,
      }));
    } catch (error) {
      console.log(
        "Error in " +
          this.displayName +
          ".handelOnChangeSelectionCrewType function",
        error,
      );
    }
  };
  handleOnSubmit = async (e) => {
    e.preventDefault();
    try {
      if (this.isFormValid()) {
        let msg = `Are you sure want to add`;
        let title = "Booking Hotel Priority";
        let isConfirm = await this.isConfirm("add", msg, title);
        if (!isConfirm) {
          return;
        }
        this.setState((prev) => ({
          ...prev,
          isSubmitted: true,
        }));
        var request = {};

        request.AirlineCode = sessionStorage.getItem("session_airlineCode");
        request.AirportCode = this.state.airportCode;
        request.HotelCode = this.state.hotelCode;
        request.CrewType =
          this.state.crewTypeCategoryCode === "both"
            ? ["P", "F"]
            : [`${this.state.crewTypeCategoryCode}`];
        request.UserId = parseInt(sessionStorage.getItem("session_userId"));
        const response = await axiosPost(
          "HotelBooking/insert-hotel-priority",
          request,
        );
        this.setState((prev) => ({
          ...prev,
          isSubmitted: false,
        }));
        if (response?.isSuccess) {
          await Swal.fire({
            allowOutsideClick: false,
            icon: response?.isSuccess ? "success" : "error",
            title: response?.isSuccess ? "Success" : "Oops...",
            text:
              response?.isSuccess === false &&
              (response?.message === null || response?.message === "")
                ? "Unable to process the request."
                : response?.message === null || response?.message === ""
                  ? `Hotel has been added ${title} successfully.`
                  : response?.message,
          }).then(async (result) => {
            if (result.isConfirmed) {
              this.handleOnCloseSetPriorityModal();
              await this.getHotelBookingPriority();
            }
          });
        } else {
          toast.error(
            response?.message === null || response?.message === ""
              ? "Unable to process the request."
              : response?.message,
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
              style: { width: "310px" },
              hideProgressBar: false,
              newestOnTop: false,
              closeButton: false,
            },
          );
        }
      }
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleOnSubmit function",
        error,
      );

      this.setState((prev) => ({
        ...prev,
        isSubmitted: false,
      }));
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    }
  };
  isFormValid = () => {
    let formIsValid = true;
    try {
      let err = this.state.errors;
      err.airport = "";
      err.hotel = "";
      err.crewTypeCategoryCode = "";
      if (this.state.airportCode.trim() === "") {
        formIsValid = false;
        err.airport = "Please select airport";
      }
      if (this.state.hotelCode.trim() === "") {
        formIsValid = false;
        err.hotel = "Please select hotel";
      }
      if (this.state.crewTypeCategoryCode.trim() === "") {
        formIsValid = false;
        err.crewTypeCategoryCode = "Please select crew booking for";
      }
      this.setState((prev) => ({
        ...prev,
        errors: err,
      }));
    } catch (error) {
      formIsValid = false;
      console.log(
        "Error in " + this.displayName + ".isFormValid function",
        error,
      );
    }
    return formIsValid;
  };
  handleOnItemReordered = async (item) => {
    try {
      const { group } = { ...item.itemIndex };
      this.reorderGroupNo = group;
      item.component.expandGroup(group);
      const { items } = item.component.option("items")[group];
      let priorityItemsRequest = [];
      items.forEach((element, index) => {
        const { airlineCode, airportCode, hotelCode, crewType, gender } = {
          ...element,
        };
        let item = {};
        item.AirlineCode = airlineCode;
        item.AirportCode = airportCode;
        item.HotelCode = hotelCode;
        item.CrewType = crewType;
        item.Priority = index + 1;
        priorityItemsRequest.push(item);
      });
      //await new Promise((resolve) => setTimeout(resolve, 1000)); // 0.5 sec
      let request = {};
      request.UserId = parseInt(sessionStorage.getItem("session_userId"));
      request.Data = priorityItemsRequest;
      const response = await axiosPost(
        "HotelBooking/update-hotel-priority",
        request,
      );
      if (response?.isSuccess) {
        let hotelPriority = [
          ...new Set(this.state.hotelBookingPriorityDataSource),
        ];
        hotelPriority.forEach((el) => {
          let priotityData = priorityItemsRequest.filter(
            (f) =>
              f.AirlineCode === el.airlineCode &&
              f.AirportCode === el.airportCode &&
              f.HotelCode === el.hotelCode &&
              f.CrewType === el.crewType,
          )[0];
          if (priotityData) {
            el.priority = priotityData.Priority;
          }
          return el;
        });
        this.setState((prev) => ({
          ...prev,
          hotelBookingPriorityDataSource: hotelPriority,
          loadPanelVisible: false,
        }));
      }
      if (!response?.isSuccess) {
        toast.error(
          response?.message === null || response?.message === ""
            ? "Unable to process the request."
            : response?.message,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          },
        );
        await this.getHotelBookingPriority();
      }
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleOnItemReordered function",
        error,
      );
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    }
  };
  handleOnItemDelete = async (e) => {
    try {
      e.cancel = true;
      const { group } = { ...e.itemIndex };
      this.reorderGroupNo = group;
      const {
        rowIndex,
        airlineCode,
        airportCode,
        hotelCode,
        hotelName,
        crewType,
      } = {
        ...e.itemData,
      };
      let msg = `${hotelName}`;
      let title = "Delete Booking Hotel Priority";
      let isConfirm = await this.isConfirm("delete", msg, title);
      if (!isConfirm) {
        return;
      }
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));

      await new Promise((resolve) => setTimeout(resolve, 1000)); // 0.5 sec
      let request = {
        AirlineCode: airlineCode,
        AirportCode: airportCode,
        HotelCode: hotelCode,
        CrewType: crewType,
      };
      request.UserId = parseInt(sessionStorage.getItem("session_userId"));
      const response = await axiosPost(
        `HotelBooking/${rowIndex}/delete-hotel-priority`,
        request,
      );
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
      }));
      if (response?.isSuccess) {
        e.cancel = false;
        await Swal.fire({
          allowOutsideClick: false,
          icon: "success",
          title: "Success",
          text:
            response?.message === null || response?.message === ""
              ? `Hotel has been delete
              successfully.`
              : response?.message,
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.getHotelBookingPriority();
            e.component.expandGroup(group);
          }
        });
      } else {
        toast.error(
          response?.message === null || response?.message === ""
            ? "Unable to process the request."
            : response?.message,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          },
        );
      }
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".handleOnItemDelete function",
        error,
      );
      toast.error("Something went wrong! Unable to process the request.", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        style: { width: "310px" },
        hideProgressBar: false,
        newestOnTop: false,
        closeButton: false,
      });
    }
  };
  isConfirm = async (type, msg, title) => {
    let isResult = false;
    let confirmMessage = "";
    if (type === "delete") {
      if (msg !== "") {
        confirmMessage = "Are you sure want to delete this <b>" + msg + "</b>?";
      } else {
        confirmMessage = "Are you sure want to delete this ?";
      }
    } else if (type === "status") {
      confirmMessage = msg;
    } else {
      confirmMessage =
        "Are you sure want to " +
        (type === "add" ? "Add" : "Update") +
        " this configuration?";
    }
    await Swal.fire({
      title: title,
      html: "<small>" + confirmMessage + "</small>",
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText:
        type === "delete" ? "Delete" : type === "add" ? "Add" : title,
    }).then(async (result) => {
      if (result.isConfirmed) {
        isResult = true;
      }
    });
    return isResult;
  };
  render() {
    return (
      <>
        <div className="card" style={{ height: "90vh" }}>
          <div className="card-body">
            <div className="row">
              <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <div className="form-group">
                  <SelectBox
                    dataSource={this.state.filterAirportDropdownDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Airport"
                    name="ddlairport"
                    displayExpr="airportCode"
                    valueExpr="airportCode"
                    value={this.state.filterAirportCode}
                    onValueChanged={this.handleOnFilterAirportDropdownChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                  {this.state.errors.filterAirport.length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors.filterAirport}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handelOnGetHotelBookingPriority}
                  >
                    {this.state.isFiltered && (
                      <span title="Filter">
                        <i className="fas fa-spinner fa-spin"></i> Filter
                      </span>
                    )}
                    {!this.state.isFiltered && (
                      <span title="Filter">
                        <i className="fas fa-filter"></i> Filter
                      </span>
                    )}
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      this.setState((prev) => ({
                        ...prev,
                        showSetPriorityModal: true,
                      }));
                    }}
                  >
                    <span title="">
                      <i className="fas fa-plus"></i> Set Hotel Priority
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <List
                    ref={this.refList}
                    dataSource={
                      new DataSource({
                        store: this.state.hotelBookingPriorityDataSource,
                        sort: "priority",
                        group: "groupText",
                        paginate: true,
                        pageSize: 10,
                      })
                    }
                    height={600}
                    width={600}
                    keyExpr="rowIndex"
                    displayExpr="hotelName"
                    grouped={true}
                    itemRender={ItemTemplate}
                    collapsibleGroups={true}
                    searchEnabled={true}
                    searchExpr={["hotelName", "crewTypeCategory", "genderText"]}
                    searchMode="contains"
                    onContentReady={(e) => {
                      // var items = e.component.option("items");
                      // for (var i = 0; i < items.length; i++) {
                      //   e.component.collapseGroup(i);
                      // }
                      e.component.expandGroup(this.reorderGroupNo);
                    }}
                    pageLoadMode="scrollBottom"
                    onItemReordered={this.handleOnItemReordered}
                    allowItemDeleting={true}
                    onItemDeleting={this.handleOnItemDelete}
                    indicateLoading={true}
                  >
                    <ItemDragging allowReordering={true} />
                  </List>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={this.state.showSetPriorityModal}
          style={{ content: { width: "35%" } }}
          className={"react-modal"}
          shouldCloseOnOverlayClick={false}
          contentLabel="Example Modal"
        >
          <div className="modal-header">
            <h6 className="modal-title">Add Hotel Booking Priority</h6>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.handleOnCloseSetPriorityModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label>Select Airport</label>
                  <SelectBox
                    dataSource={this.state.airportDropdownDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="All Airports"
                    name="ddlairport"
                    defaultValue={""}
                    value={this.state.airportCode}
                    displayExpr="airportCode"
                    valueExpr="airportCode"
                    onValueChanged={this.handleOnAirportDropdownChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                  {this.state.errors["airport"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["airport"]}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label>Select stay hotel</label>
                  <SelectBox
                    dataSource={this.state.hotelDropdownDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Hotel"
                    name="ddlhotel"
                    defaultValue={""}
                    value={this.state.hotelCode}
                    displayExpr="hotelName"
                    valueExpr="hotelCode"
                    onValueChanged={this.handleOnHotelDropdownChange}
                    showClearButton={true}
                    searchEnabled={true}
                  />
                  {this.state.errors["hotel"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["hotel"]}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="row pt-2">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label>Hotel Booking For</label>
                  <RadioGroup
                    id="radio-group-with-selection"
                    dataSource={this.state.crewTypeCategoryDataSource}
                    layout="horizontal"
                    value={this.state.crewTypeCategoryCode}
                    valueExpr="code"
                    displayExpr="name"
                    onValueChanged={this.handelOnChangeSelectionCrewType}
                  />
                  {this.state.errors["crewTypeCategoryCode"].length > 0 && (
                    <span className="error invalid-feedback">
                      {this.state.errors["crewTypeCategoryCode"]}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="submit"
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                this.handleOnSubmit(e);
              }}
            >
              <i
                className={`fas fa-${
                  this.state.isSubmitted ? "spinner fa-spin" : "save"
                }`}
              />
              &nbsp;Save
            </button>
            &nbsp;&nbsp;
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              title="Close"
              onClick={this.handleOnCloseSetPriorityModal}
            >
              <i className="fas fa-times" />
              &nbsp;Close
            </button>
          </div>
        </Modal>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={position}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
